import * as React from 'react';

import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import NumberFormat from 'react-number-format';
import { TEXT } from 'texts';
import { TextFieldProps } from '@material-ui/core/TextField';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks';
import { useStyles } from './CardCvvInput.styles';
import { useTranslation } from 'react-i18next';
import { IconButton, InputAdornment } from "@material-ui/core";
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import VisibilityIcon from '@material-ui/icons/Visibility';

type CardCvvInputProps = {} & TextFieldProps;

const NumberFormatCustom = (props: { inputRef?: (el: HTMLInputElement) => void; onChange?(value: unknown): void }) => {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef && inputRef}
      onValueChange={(values) => {
        onChange &&
          onChange({
            currentTarget: {
              value: values.value,
            },
          });
      }}
      format="###"
      mask=""
    />
  );
};

const CardCvvInput: React.FC<CardCvvInputProps> = ({disabled}) => {
  const { t } = useTranslation();
  const styles = useStyles();
  const { formStore } = useStores();
  const [isCvvHidden, setIsCvvHidden] = React.useState<boolean>(true);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    formStore.cvv.setValue(event.currentTarget.value);
  };

  const handleBlur = () => {
    formStore.cvv.validate();
  };

  const renderHelperText = () => {
    if (formStore.cvv.error) {
      return t(formStore.cvv.error);
    }
    return ' ';
  };

  const handleClickShowPassword = () => {
    setIsCvvHidden((prevState) => !prevState);
  };

  return (
    <FormControl fullWidth>
      <InputLabel htmlFor="credit-cvc">{t(TEXT.cvv)}</InputLabel>
      <Input
        id="credit-cvc"
        name="credit-cvc"
        placeholder="•••"
        value={formStore.cvv.value}
        onChange={handleChange}
        onBlur={handleBlur}
        type={isCvvHidden ? "password" : "tel"}
        inputMode="numeric"
        inputComponent={NumberFormatCustom}
        disabled={disabled}
        onClick={(event) => {
          window.setTimeout(function () {
            (event.target as HTMLInputElement).focus();
          }, 0);
        }}
        endAdornment={
          <InputAdornment position='end'>
            <IconButton
              aria-label='toggle password visibility'
              onClick={handleClickShowPassword}
            >
              {isCvvHidden ? <VisibilityOffIcon /> : <VisibilityIcon />}
            </IconButton>
          </InputAdornment>
        }
      />
      <FormHelperText id="credit-cvc-helper" className={styles.helper} error={!!formStore.cvv.error}>
        {renderHelperText()}
      </FormHelperText>
    </FormControl>
  );
};

export default observer(CardCvvInput);
